export enum DevicePointer {
  None = 'DevicePointerNone',
  Coarse = 'DevicePointerCoarse',
  Fine = 'DevicePointerFine',
}
